/// <amd-module name="Feed/Legacy/Helpers/OrganizationHelper" />
import { getUserOrganizations, IOrganization } from "VSS/Features/Services/OrganizationsService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import * as Utils_String from "VSS/Core/Util/String";

import { UpstreamConstants } from "Feed/Common/Contracts/WebPage";
export function getUpstreamLocator(collectionName: string, feedName: string, viewName: string, projectName?: string): string {
    const projectRoute = projectName ? `/${projectName}` : '';
    return `${UpstreamConstants.InternalLocationScheme}://${collectionName}${projectRoute}/${feedName}@${viewName}`;
}

export function isCurrentCollection(pageContext: IVssPageContext, collectionId: string): boolean {
    if (collectionId == null) {
        return true;
    }

    const pageData: IPageData = pageContext.getService<IVssPageService>("IVssPageService").getData();
    return Utils_String.equals(collectionId, pageData.hostId, true);
}

export async function getOrganizationNameAsync(pageContext: IVssPageContext, collectionId: string): Promise<string> {
    const pageData: IPageData = pageContext.getService<IVssPageService>("IVssPageService").getData();

    if (Utils_String.equals(collectionId, pageData.hostId, true)) {
        return pageData.hostName;
    }

    const collection = await getOrganizationAsync(pageContext, collectionId);
    return collection != null ? collection.name : null;
}

export async function getOrganizationAsync(pageContext: IVssPageContext, collectionId: string): Promise<IOrganization> {
    const orgCollections = await getUserOrganizations(pageContext);

    for (const collection of orgCollections) {
        if (Utils_String.equals(collectionId, collection.id, true)) {
            return collection;
        }
    }

    return null;
}
